<template>
  <div class="part mt-4">
    <div class="header_style justify-content-start">
      <h2 class="h2_style mb-0">线程函数</h2>
      <!-- <div
        @click="add"
        style="
          color: #4371fd;
          text-decoration: none;
          margin-left: 20px;
          cursor: pointer;
          align-items: center;
        "
      >
        添加指标
      </div> -->
    </div>
    
    <div class="part__cnt">
      <div class="position-relative mt-4">
        <div id="analyse" style="width: 100%; height: 400px"></div>
        <label-list ref="labelList1" :perf_second_data="perf_second_data" chartKey="analyse_chart" />
        <chart-rect ref="chartRect1" chartKey="analyse_chart" />
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import LabelList from '../label-list.vue'
import {allChart} from '../common.js'
import ChartRect from '../rect.vue'

export default {
  props: {
    chartSettings: Object,
    cpu_by_frame: Object,
    perf_second_data: Object,
  },

  components: {LabelList, ChartRect},

  data() {
    return {
      analyse_data: [],
    }
  },

  computed: {
    seriesData() {
      return this.cpu_by_frame?.series
    }
  },

  methods: {
    async init(isMounted) {
      this.drawAnalyseTrend()
      await this.$nextTick()
      this.$refs.chartRect1?.init(isMounted)
    },

    add() {
      //
    },

    getChartOption() {
      return {
        title: {
          text: "线程函数",
          textStyle: {
            fontSize: 16,
            fontWeight: 700,
            color: "#333",
          },
        },
        dataZoom: this.chartSettings.dataZoom,
        toolbox: this.chartSettings.toolbox,
        tooltip: {
          trigger: "axis",
          confine: true,
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "line", // 默认为直线，可选为：'line' | 'shadow'
          },
          className: 'echarts-tooltip',
          extraCssText: "white-space: normal; word-break: break-all;",
        },
        legend: this.chartSettings.legend,
        grid: this.chartSettings.grid,
        yAxis: this.chartSettings.yAxis,
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.cpu_by_frame?.abs_times,
          axisLabel: {
            // formatter: function (value, index) {
            //   return value * 10;
            // },
          },
        },
        series: this.analyse_data,
      }
    },

    analyse_series() {
      this.analyse_data = [];
      if (this.cpu_by_frame?.thread_list) {
        let list = Object.keys(this.cpu_by_frame?.thread_list);

        list.forEach((v, index) => {
          this.analyse_data.push({
            name: v,
            type: "line",

            showSymbol: false,

            itemStyle: {
              normal: {
                lineStyle: {
                  width: 1,
                },
              },
              emphasis: {
                lineStyle: {
                  width: 1, // hover时的折线宽度
                },
              },
            },
            yAxisIndex: 0,
            id: this.cpu_by_frame?.thread_list[v],
            data: this.cpu_by_frame?.series[index],
          })
        })
      } else {
        this.analyse_data = []
      }
    },

    drawAnalyseTrend() {
      const chartDom = document.getElementById("analyse")
      if (!chartDom) return
      if (!allChart.analyse_chart) {
        allChart.analyse_chart = echarts.init(chartDom)
      }
      this.analyse_series()
      allChart.analyse_chart.setOption(this.getChartOption(), {notMerge: true})
    },
  }
}
</script>

<style scoped>
@import "../common.css"
</style>